import { useState } from "react";

export function useD20Roll() {
  const [result, setResult] = useState(null);

  const roll = ({
    label,
    modifier = 0,
    multiplier = 1,
    details = [],
    modifierBreakdown,
  }) => {
    const die = Math.floor(Math.random() * 20) + 1;
    const baseTotal = die + modifier;
    const breakdown = modifierBreakdown ?? (
      modifier !== 0 ? [{ label: "Base modifier", value: modifier }] : []
    );
    setResult({
      label,
      die,
      modifier,
      modifierBreakdown: breakdown,
      multiplier,
      total: baseTotal * multiplier,
      details,
    });
  };

  return { result, roll, showResult: setResult, closeRoll: () => setResult(null) };
}